import React from 'react';
import { useStyletron } from 'baseui';
import { Select } from 'baseui/select';
import { Button } from 'baseui/button';
import { FEATURE_TYPE_OPTIONS, PAYMENT_GATEWAY_NAME_OPTIONS, IS_ACTIVE_OPTIONS, SDFilters } from '../../utils/constants';
import { filterContainer, filterItem, filterItemButton, filterItemLabel } from './style';

const PaymentPGFailureFilter = (props: any) => {
	const { handleFormSubmit, PG_NAME_OPTIONS } = props;
	const [css] = useStyletron();
	const [notificationType, setNotificationType] = React.useState<any>(FEATURE_TYPE_OPTIONS[0]);
	const [merchantName, setMerchantName] = React.useState<any>(PAYMENT_GATEWAY_NAME_OPTIONS[0]);
	const [isActive, setIsActive] = React.useState<any>(IS_ACTIVE_OPTIONS[0]);
	return (
		<>
			<div className={css(filterContainer)}>
				<div className={css(filterItem)}>
					Notification Type <span className={css(filterItemLabel)}>*</span>
					<div>
						<Select
							options={FEATURE_TYPE_OPTIONS}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => {
								setNotificationType(option);
							}}
							value={[notificationType]}
						/>
					</div>
				</div>
				<div className={css(filterItem)}>
					Merchant Name <span className={css(filterItemLabel)}>*</span>
					<div>
						<Select
							options={PG_NAME_OPTIONS.length > 0 ? PG_NAME_OPTIONS : PAYMENT_GATEWAY_NAME_OPTIONS}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => setMerchantName(option)}
							value={[merchantName]}
						/>
					</div>
				</div>
				<div className={css(filterItem)}>
					Is Active{' '}
					<div>
						<Select
							options={IS_ACTIVE_OPTIONS as any}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => setIsActive(option)}
							value={[isActive]}
						/>
					</div>
				</div>
				<div className={css(filterItemButton)}>
					<Button
						size='default'
						onClick={() => {
							const filterData: SDFilters = {
								notificationType: notificationType?.id,
								isActive: isActive?.id,
								merchantName: merchantName?.id
							};
							handleFormSubmit(filterData);
						}}>
						Submit
					</Button>
				</div>
			</div>
		</>
	);
};

export default PaymentPGFailureFilter;
